<!-- ===== REFONTE : sélection du personnel Force-N ===== -->
<div *ngIf="showPopup" class="pf-overlay" (click)="annuler()">
  <div
    class="pf-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pf-titre"
    (click)="$event.stopPropagation()"
  >
    <!-- En-tête -->
    <header class="pf-header">
      <div>
        <h2 id="pf-titre" class="pf-title">Participants de l'atelier</h2>
        <p class="pf-subtitle">
          Personnel Force-N · {{ personnel.length }} personnes
        </p>
      </div>
      <button
        type="button"
        class="pf-close"
        (click)="annuler()"
        aria-label="Fermer"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
    </header>

    <!-- Recherche et filtres -->
    <div class="pf-tools">
      <div class="pf-search">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" />
        </svg>
        <input
          type="text"
          class="pf-input"
          [formControl]="UsersearchCtrl"
          placeholder="Rechercher un nom, un email ou un profil"
        />
      </div>

      <div class="pf-filters" *ngIf="profils.length > 1">
        <button
          type="button"
          class="pf-filter"
          [class.is-active]="!profilActif"
          (click)="choisirProfil('')"
        >
          Tous
        </button>
        <button
          *ngFor="let p of profils"
          type="button"
          class="pf-filter"
          [class.is-active]="profilActif === p"
          (click)="choisirProfil(p)"
        >
          {{ p }}
        </button>
      </div>
    </div>

    <!-- ===== DÉBUT AJOUT : tout sélectionner (liste filtrée, toutes pages) ===== -->
    <button
      *ngIf="usersFiltres.length > 0"
      type="button"
      class="pf-select-all"
      [class.is-selected]="tousFiltresSelectionnes"
      [class.is-partial]="selectionPartielle"
      [attr.aria-pressed]="
        tousFiltresSelectionnes
          ? 'true'
          : selectionPartielle
            ? 'mixed'
            : 'false'
      "
      (click)="basculerTousFiltres()"
    >
      <span class="pf-sa-case" aria-hidden="true">
        <svg
          *ngIf="tousFiltresSelectionnes"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12l5 5L20 7" />
        </svg>
        <svg
          *ngIf="selectionPartielle"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
        >
          <path d="M6 12h12" />
        </svg>
      </span>
      <span class="pf-sa-libelle">{{ libelleToutSelectionner }}</span>
      <span class="pf-sa-compte"
        >{{ nbFiltresSelectionnes }} / {{ usersFiltres.length }}</span
      >
    </button>
    <!-- ===== FIN AJOUT ===== -->

    <!-- Liste -->
    <div class="pf-list">
      <ng-container *ngIf="filteredUsers$ | async as users; else chargement">
        <button
          *ngFor="let u of users"
          type="button"
          class="pf-row"
          [class.is-selected]="isSelected(u)"
          [attr.aria-pressed]="isSelected(u)"
          (click)="basculer(u)"
        >
          <span class="pf-avatar">{{ initiales(u) }}</span>
          <span class="pf-person">
            <span class="pf-name">{{ u.firstname }} {{ u.lastname }}</span>
            <span class="pf-email">{{ u.email }}</span>
          </span>
          <!-- MODIF : libellés du back ; title pour lire en entier si plusieurs profils -->
          <span class="pf-role" [title]="libelleProfils(u)">{{
            libelleProfils(u)
          }}</span>
          <span class="pf-check" aria-hidden="true">
            <svg
              *ngIf="isSelected(u)"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12l5 5L20 7" />
            </svg>
          </span>
        </button>

        <p *ngIf="users.length === 0" class="pf-empty">
          Aucune personne ne correspond à la recherche.
        </p>
      </ng-container>

      <ng-template #chargement>
        <p class="pf-empty">Chargement du personnel…</p>
      </ng-template>
    </div>

    <!-- Pagination -->
    <div class="pf-pagination" *ngIf="totalElements > itemsPerPage4Users">
      <span>{{ debutPage }} – {{ finPage }} sur {{ totalElements }}</span>
      <span class="pf-pages">
        <button
          type="button"
          (click)="pagePrecedente()"
          [disabled]="pageCourante <= 1"
          aria-label="Page précédente"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M15 6l-6 6 6 6" />
          </svg>
        </button>
        <button
          type="button"
          (click)="pageSuivante()"
          [disabled]="pageCourante >= totalPages4Users"
          aria-label="Page suivante"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        </button>
      </span>
    </div>

    <!-- Pied -->
    <footer class="pf-footer">
      <span class="pf-count">
        <strong>{{ personnelChoisi.length }}</strong> sélectionnée(s)
        <button
          *ngIf="personnelChoisi.length"
          type="button"
          class="pf-link"
          (click)="toutDeselectionner()"
        >
          · Tout désélectionner
        </button>
      </span>
      <span class="pf-actions">
        <button type="button" class="pf-btn-secondary" (click)="annuler()">
          Annuler
        </button>
        <button type="button" class="pf-btn-primary" (click)="valider()">
          Valider
        </button>
      </span>
    </footer>
  </div>
</div>
<!-- ===== FIN REFONTE ===== -->
